import {Injectable} from '@angular/core';
import {
  IResourceMethod,
  ResourceAction,
  ResourceHandler,
  ResourceParams,
  ResourceRequestMethod
} from '@ngx-resource/core';
import {CategoriaDocumentoModel} from './categoria-documento.model';
import {DocumentosModel} from './documentos.model';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class DocumentosResource extends ResourceAuth {
  constructor(restHandler: ResourceHandler, authProv: AuthServerProvider) {
    super(restHandler, authProv);
  }

// export class DocumentosResource extends Resource {
  //  constructor(restHandler: ResourceHandler) {
  //   super(restHandler);
  // }

  @ResourceAction({
    path: '/categoria_documento'
  })
  lodListaCategoriasDocumento: IResourceMethod<any, CategoriaDocumentoModel[]>;

  @ResourceAction({
    path: '/categoria_documento',
    method: ResourceRequestMethod.Post
  })
  insercionMasivaCategoriaDocumento: IResourceMethod<CategoriaDocumentoModel[], any>;

  @ResourceAction({
    path: '/categoria_documento/{!_id}',
    method: ResourceRequestMethod.Patch
  })
  updCategoriaDocumento: IResourceMethod<CategoriaDocumentoModel, any>;

  @ResourceAction({
    path: '/categoria_documento/{!id}',
    method: ResourceRequestMethod.Delete
  })
  dltCategoriaDocumento: IResourceMethod<{ id: any }, any>;

  @ResourceAction({
    path: '/documento/{!id}'
  })
  lodDocumento: IResourceMethod<{ id: string }, DocumentosModel>;

  @ResourceAction({
    path: '/documento'
  })
  lodListaDocumentos: IResourceMethod<any, DocumentosModel[]>;

  @ResourceAction({
    path: '/documento',
    method: ResourceRequestMethod.Post
  })
  insercionDocumento: IResourceMethod<DocumentosModel, any>;

  @ResourceAction({
    path: '/documento/{!_id}',
    method: ResourceRequestMethod.Patch
  })
  updDocumento: IResourceMethod<DocumentosModel, any>;

  @ResourceAction({
    path: '/documento/{!id}',
    method: ResourceRequestMethod.Delete
  })
  dltDocumento: IResourceMethod<{ id: any }, any>;

  @ResourceAction({
    path: '/na/documentos_public/{!id}'
  })
  lodDocumentosPublic: IResourceMethod<{ id: string }, DocumentosModel[]>;
}
